// import { useState } from 'react';
import { DisplayFeed } from '@/domains/User/components/DisplayFeed/DisplayFeed';
// import { FilterValues } from '../constants/FilterValues';
// import { ContentCard } from './ContentCard';
// import { DiscussionCard } from './ContentCard/DiscussionCard';

export const RenderContent = ({
  content,
  commentsCollapsed,
  handleToggleCollapse,
}) => {
  return (
    <DisplayFeed
      feedContent={content}
      collapsed={content.contentId !== commentsCollapsed}
      onToggleCollapse={handleToggleCollapse}
      groupPage
    />
  );

  // const { contentType } = content ?? {};

  // if (contentType === FilterValues.PRODUCT) return null;

  // if (contentType === FilterValues.DISCUSSIONS)
  //   return <DiscussionCard content={content} />;

  // return <ContentCard content={content} />;
};
